import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { RoadmapPage } from "@/components/roadmap/roadmap-page";
import { parseRoadmapSearch, type RoadmapSearch } from "@/components/roadmap/search";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/roadmap")({
  // Which item is open lives in the URL and nowhere else. Whatever the URL
  // says, this returns a page that can be drawn: it never throws.
  validateSearch: (search: Record<string, unknown>): RoadmapSearch => parseRoadmapSearch(search),
  component: RoadmapRoute,
});

function RoadmapRoute() {
  const { projectSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (next: RoadmapSearch) => void navigate({ search: next }),
    [navigate],
  );
  // Keyed by project: the open item is one project's.
  return <RoadmapPage key={projectSlug} search={search} onSearchChange={setSearch} />;
}
